import React, { useCallback } from 'react';
import { Modal, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  toggleCampaignCreatedModal,
  toggleCampaignInfoModal,
  toggleUploadAssetModal
} from '@redux/actions/modalAction';
import { useTypedSelector } from '@hooks';
import { openNewTaskModal } from '@redux/reducers/tasks';
import {
  AddCampaignDetailsIcon,
  AddCampaignTaskIcon,
  CrossIcon,
  UploadCampaignFilesIcon
} from '@icons';

function CampaignCreatedModal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const campaignCreatedModal = useTypedSelector(
    ({ modal }) => modal.campaignCreatedModal
  );
  const campaign = campaignCreatedModal?.campaign;

  const onCloseModal = useCallback(() => {
    dispatch(toggleCampaignCreatedModal(null));
    if (!campaign?.id) return;
    navigate(`/campaigns/single/${campaign.id}`);
  }, [navigate, dispatch, campaign?.id]);

  return (
    <Modal
      visible={campaignCreatedModal?.visible}
      footer={null}
      centered={true}
      destroyOnClose
      closeIcon={<CrossIcon />}
      width={964}
      onCancel={onCloseModal}
    >
      <div className="modal_container">
        <h2
          className="modal_container__title"
          style={{
            fontSize: 22,
            marginBottom: '0.5em',
            textAlign: 'center',
            justifyContent: 'center'
          }}
        >
          Ready to get started?
        </h2>
        <p
          className="modal_container__subtitle"
          style={{ textAlign: 'center' }}
        >
          Choose what you want to do first.
        </p>
        <div className="modal_container__campaign">
          <div className="actions_block">
            <div className="action">
              <div className="action__icon">
                <AddCampaignDetailsIcon />
              </div>
              <div className="action__info">
                <div className="title">Add details</div>
                <div className="description">Add details to project</div>
                <Button
                  onClick={() => {
                    dispatch(toggleCampaignCreatedModal(null));
                    if (!campaign) return;
                    dispatch(
                      toggleCampaignInfoModal({
                        campaign,
                        activeTab: 'details',
                        visible: true
                      })
                    );
                    navigate(`/campaigns/single/${campaign.id}`);
                  }}
                  type="primary"
                >
                  Add details
                </Button>
              </div>
            </div>
            <div className="action">
              <div className="action__icon">
                <UploadCampaignFilesIcon />
              </div>
              <div className="action__info">
                <div className="title">Upload files</div>
                <div className="description">Upload new files to project</div>
                <Button
                  type="primary"
                  onClick={() => {
                    dispatch(toggleCampaignCreatedModal(null));
                    if (!campaign) return;
                    dispatch(
                      toggleUploadAssetModal({
                        visible: true,
                        postAction: 'redirect-to-campaign',
                        workspaceId: campaign.workspaceId,
                        campaignId: campaign.id
                      })
                    );
                    navigate(`/campaigns/single/${campaign.id}`);
                  }}
                >
                  Upload files
                </Button>
              </div>
            </div>
            <div className="action">
              <div className="action__icon">
                <AddCampaignTaskIcon />
              </div>
              <div className="action__info">
                <div className="title">Add new task</div>
                <div className="description">Add tasks to project</div>
                <Button
                  type="primary"
                  size="middle"
                  onClick={() => {
                    dispatch(toggleCampaignCreatedModal(null));
                    if (!campaign) return;
                    dispatch(
                      openNewTaskModal({
                        organizationId: campaign.organizationId,
                        workspaceId: campaign.workspaceId,
                        campaign
                      })
                    );
                    navigate(`/campaigns/single/${campaign.id}?tab=tasks`);
                  }}
                >
                  Add task
                </Button>
              </div>
            </div>
          </div>
        </div>
        <Button
          type="ghost"
          size="large"
          style={{
            display: 'flex',
            margin: '0 auto',
            fontSize: 14,
            fontWeight: 700,
            border: 'none',
            height: 'auto',
            padding: '4px 0px'
          }}
          onClick={onCloseModal}
        >
          Skip
        </Button>
      </div>
    </Modal>
  );
}

export default CampaignCreatedModal;
